
import MemberPreview from '~/components/community/MemberPreview.vue';
import communityinfo from '~/helpers/communityinfo';
export default {
  components: { MemberPreview },
  data () {
    return {
      gesine: communityinfo[1],
      louis: communityinfo[2],
      sara: communityinfo[0],
      andre: communityinfo[3],
      vanessa: communityinfo[4],
      kathrin: communityinfo[5],
      moellersmann: communityinfo[6],
      pomella: communityinfo[7]
    };
  }

};
